import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import UploadButton from 'components/upload-button/index';
import * as CommonActionType from 'Common/constants';
import * as AuthActionType from 'Auth/constants';
import * as ProjectActionType from '../constants';
import PubSub from 'services/pubsub-service';
import * as PubSubActionType from 'services/constants';

class ProjectAddEditImportSection extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    sectionKey: PropTypes.string,
    projectId: PropTypes.string,
    ImportStatus: PropTypes.object,
    ProjectProfile: PropTypes.object,
    ImportData: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      file: null,
      isImporting: false,
      result: null,
      projectName: '',
      error: null
    };
  }

  componentDidMount() {
    const { projectId, ImportData, ProjectProfile, sectionKey } = this.props;

    this.props.dispatch({
      type: ProjectActionType.GET_IMPORT_STATUS_BY_PROJECT_ASYNC,
      params: {
        projectId: projectId
      },
      callback: data => {
        if (
          data &&
          (data.hasImportFileInQueue || data.inProgress) &&
          this.mapTypeSection(data.type) === this.props.sectionKey
        ) {
          this.setState({ isImporting: true });

          const projectImportData = ImportData.find(
            x => x.projectName === ProjectProfile.name
          );

          if (projectImportData && projectImportData.type === sectionKey) {
            //dispatch action to dismiss popup importing
            this.props.dispatch({
              type: AuthActionType.REMOVE_ITEM_IN_IMPORT_DATA,
              data: {
                projectName: ProjectProfile.name
              }
            });
          }
        }
      }
    });

    this.onSubscribeImportProgress(
      PubSubActionType.IMPORT_REQUEST_FOR_SERVICES_PROGRESS_UPDATE,
      'rfs'
    );
    this.onSubscribeImportProgress(
      PubSubActionType.IMPORT_WORK_ORDERS_PROGRESS_UPDATE,
      'workOrder'
    );
    this.onSubscribeImportProgress(
      PubSubActionType.IMPORT_PURCHASE_ORDERS_PROGRESS_UPDATE,
      'purchaseOrder'
    );
  }

  componentWillUnmount() {
    const { isImporting } = this.state;

    const { ImportData, ProjectProfile, projectId, sectionKey } = this.props;

    //dispatch action to display popup importing if in progress import
    if (
      isImporting &&
      !ImportData.some(x => x.projectName === ProjectProfile.name)
    ) {
      this.props.dispatch({
        type: AuthActionType.ADD_ITEM_TO_IMPORT_DATA,
        data: {
          projectId,
          projectName: ProjectProfile.name,
          type: sectionKey
        }
      });
    }
  }

  onSubscribeImportProgress = (actionType, section) => {
    PubSub.subscribe(actionType, (msg, data) => {
      const {
        firstConfiguredRowsErrorOccurred,
        numberOfErrorItems,
        numberOfInsertedItems,
        numberOfUpdatedItems,
        totalItems,
        projectName
      } = data.message;

      const { sectionKey } = this.props;

      if (
        (sectionKey === section &&
          numberOfErrorItems + numberOfInsertedItems + numberOfUpdatedItems ===
            totalItems) ||
        firstConfiguredRowsErrorOccurred
      ) {
        //hidden loading icon and display result
        this.setState({
          isImporting: false,
          result: data.message,
          projectName
        });
      }
    });
  };

  onHandleFileUpload(e) {
    //https://gist.github.com/AshikNesin/e44b1950f6a24cfcd85330ffc1713513
    let file = e.target.files[0];

    if (file.name.indexOf('.csv') === -1) {
      this.setState({ error: 'Only .csv supported' });
      return;
    }

    file.uploadId = uuidv4();

    this.setState(
      {
        file,
        isImporting: true,
        result: null,
        error: null
      },
      () => {
        const { projectId } = this.props;

        this.props.dispatch({
          type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
          params: {
            resourcePath: `projects/${projectId}/import`
          },
          callback: awsCredential => {
            this.props.dispatch({
              type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
              paramsUpload: {
                projectId,
                file,
                config: awsCredential
              },
              callback: this.onStartImport
            });
          }
        });
      }
    );
  }

  onStartImport = (status, callbackData) => {
    const { file } = this.state;

    const { sectionKey, projectId } = this.props;

    let actionType = '';

    if (sectionKey === 'rfs') {
      actionType = ProjectActionType.IMPORT_RFS_TO_PROJECT_ASYNC;
    } else if (sectionKey === 'workOrder') {
      actionType = ProjectActionType.IMPORT_WORK_ORDER_TO_PROJECT_ASYNC;
    } else {
      //sectionKey === 'purchaseOrder'
      actionType = ProjectActionType.IMPORT_PURCHASE_ORDER_TO_PROJECT_ASYNC;
    }

    if (status === true && actionType) {
      this.props.dispatch({
        type: actionType,
        params: {
          projectId: projectId,
          data: {
            key: callbackData.data.Key,
            url: callbackData.data.Location,
            fileName: file.name
          }
        }
      });
    }
  };

  mapTypeSection = type => {
    const typeEnum = {
      0: 'rfs',
      1: 'workOrder',
      2: 'purchaseOrder'
    };

    return typeEnum[type];
  };

  renderImportResult = result => {
    const {
      firstConfiguredRowsErrorOccurred,
      firstConfiguredRowsToStop,
      numberOfErrorItems,
      numberOfInsertedItems,
      numberOfUpdatedItems,
      totalItems,
      runLogFile
    } = result;

    if (firstConfiguredRowsErrorOccurred) {
      return (
        <div className='import-result'>
          <div className='import-error import-result-status'>
            <i className='fa fa-exclamation-circle' aria-hidden='true' />
            <span>
              <span style={{ color: 'red', textDecoration: 'underline' }}>
                {firstConfiguredRowsToStop} invalid rows
              </span>{' '}
              detected. The import process is cancelled because all of the first{' '}
              {firstConfiguredRowsToStop} rows contain errors. Please make sure
              you follow our guide of import data.
            </span>
          </div>
        </div>
      );
    } else if (
      numberOfErrorItems + numberOfInsertedItems + numberOfUpdatedItems ===
      totalItems
    ) {
      return (
        <div className='import-result'>
          <div className='import-error import-result-status'>
            <i className='fa fa-exclamation-circle' aria-hidden='true' />
            <span>
              <a
                href={runLogFile}
                style={{ color: 'red', textDecoration: 'underline' }}
              >
                {numberOfErrorItems} invalid rows
              </a>{' '}
              detected.
            </span>
          </div>
          <div className='import-success import-result-status'>
            <i className='fa fa-check-circle' aria-hidden='true' />
            <span>{numberOfInsertedItems} rows added.</span>
          </div>
          <div className='import-success import-result-status'>
            <i className='fa fa-check-circle' aria-hidden='true' />
            <span>{numberOfUpdatedItems} rows updated.</span>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  renderInfo = () => {
    const { result, isImporting } = this.state;

    const { ImportData, ImportStatus, ProjectProfile, sectionKey } = this.props;

    const projectImportData = ImportData.find(
      x => x.projectName === ProjectProfile.name
    );

    if (result && isImporting) {
      return null;
    }

    if (
      (projectImportData && projectImportData.type !== sectionKey) ||
      (ImportStatus &&
        ImportStatus.type &&
        this.mapTypeSection(ImportStatus.type) !== sectionKey)
    ) {
      return (
        <div
          className='alert alert-info'
          style={{ margin: '10px auto', backgroundColor: '#6addf4' }}
        >
          There is one import process for this project at this moment. Please
          wait until this process completes.
        </div>
      );
    }
    return null;
  };

  render() {
    const { isImporting, result, projectName, error } = this.state;

    const { ImportData, ProjectProfile } = this.props;

    return (
      <div className='import-section'>
        {this.renderInfo()}

        <p style={{ fontSize: 14, margin: '0 0 5px 0' }}>
          You are highly recommended to download our excel template so that you
          won't waste your time uploading a file with incorrect format.
        </p>
        {/*
        <div style={{ marginBottom: 10 }}>
          <a
            href={`${window.profile.currentSiteUri}/api/static-files/download-lot-tmpl`}
            style={{ textDecoration: 'underline' }}
          >
            Download excel template
          </a>
        </div>
        */}
        {isImporting && (
          <div
            style={{ display: 'flex', alignItems: 'center', margin: '20px 0' }}
          >
            <img
              src='/images/spinner.gif'
              alt='s1-spinner'
              style={{ width: 35, height: 'auto' }}
            />
            <span style={{ marginLeft: 15 }}>Importing...</span>
          </div>
        )}

        {projectName &&
          projectName === ProjectProfile.name &&
          result &&
          this.renderImportResult(result)}

        {error && <div className='text-danger'>{error}</div>}

        {!isImporting && (
          <UploadButton
            name='upload-csv'
            accept='.csv'
            label='Import...'
            disabled={
              !result &&
              ImportData.find(x => x.projectName === ProjectProfile.name)
            }
            tooltip='Supported file types: .csv'
            onChange={this.onHandleFileUpload.bind(this)}
            ref={el => {
              this.uploadFile = el;
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ImportStatus: state.ProjectStore.ImportStatus,
    ProjectProfile: state.ProjectStore.ProjectProfile,
    ImportData: state.authReducer.ImportData
  };
};

export default connect(mapStateToProps)(ProjectAddEditImportSection);



// WEBPACK FOOTER //
// ./src/Projects/Containers/project-add-edit-import-section.js